import axios from 'axios';
// Apuntará a tu dominio público.
const api = axios.create({
    baseURL: 'https://api.elgransurtidor.com',
    //baseURL: 'http://localhost:5002',
});

export default api;
